
export function getdata() {
	var obj = {

		formlist: [{
			prop: "tudbh",
			label: "土地编号",
			isnotnull: true,
			type: "input",
		}, {
			prop: "zondh",
			label: "宗地号",
			type: "input",
		}, {
			prop: "tudmc",
			label: "土地名称	",
			type: "input",
		}, {
			prop: "nsrlx",
			label: "纳税人类型",
			isnotnull: true,
			type: "select",
			selectval: []
		}, {
			prop: "tudsyqNsrsbh",
			label: "土地使用权人纳税人识别号 (统一社会信用)",
			type: "input",
		}, {
			prop: "tudsyqMc",
			label: "土地使用权人名称",
			type: "input",
		}, {
			prop: "budcqzh",
			label: "不动产权证号",
			type: "input",
		}, {
			prop: "tudxz",
			label: "土地性质",
			type: "select",
			isnotnull: true,

		}, {
			prop: "tudyt",
			label: "土地用途",
			isnotnull: true,
			type: "select",
			isnotnull: true,

		}, {
			prop: "tudqdsj",
			label: "初始取得时间",
			isnotnull: true,
			type: "date",
			isdate: true,
			valueformat: "yyyy-MM-dd",
		}, {
			prop: "tudqdfs",
			label: "土地取得方式",
			isnotnull: true,
			type: "select",
		}, {
			prop: "zhanytdmj",
			label: "占用土地面积",
			isnotnull: true,
			type: "input",
		}, {
			prop: "budcdydm",
			label: "不动产单元代码",
			type: "input",
		}, {
			prop: "shuiebz",
			label: "税额标准",
			isnotnull: true,

			type: "input",
		},{
			prop: "nsywYxqq",
			label: "纳税义务有效期起",
			type: "date",
			isdate: true,
			isnotnull: true,

			valueformat:'yyyy-MM-dd'
		},
		{
			prop: "tudzldzShi",
			label: "",
			type: "input",
			slot: true
		}, {
			prop: "tudzldzXiangz",
			label: "土地坐落地址(所处街乡)",
			isnotnull: true,
			type: "select",
			selectval: []
		}, {
			prop: "tudzldzXx",
			label: "土地坐落详细地址",
			isnotnull: true,
			type: "input",
		}, {
			prop: "tudsszgsws",
			label: "主管税务所(科，分局)",
			isnotnull: true,
			type: "input",
		}, {
			prop: "pikbz",
			label: "批扣标志",
			type: "select",
			selectval: [{
				value: '0',
				label: '是',
			}, {
				value: '1',
				label: '否',
			}]
		},{
			prop: "dij",
			label: "地价",
			type: "input",
		}, {
			prop: "qudtdsyqje",
			label: "其中取得土地使用权支付金额",
			type: "input",
		}, {
			prop: "tudkfcb",
			label: "其中土地开发成本",
			type: "input",
		},  {
			prop: "jingbr",
			label: "经办人",
			type: "input",
		},{
			prop: "jingbrsfzhm",
			label: "经办人身份证件号码",
			type: "input",
		}, {
			prop: "shoulr",
			label: "受理人",
			type: "input",
		}, {
			prop: "shoulrq",
			label: "受理日期",
			type: "date",
			isdate: true,
			valueformat: "yyyy-MM-dd",
		}, {
			prop: "shoulswjg",
			label: "受理税务机关",
			type: "input",
		},{
			prop: "tuddj",
			label: "土地等级",
			isnotnull: true,

			type: "select",
		},{
			prop: "nsywYxqz",
			label: "纳税义务有效期止",
			type: "date",
			isdate: true,
			isnotnull: true,
			disabled:true,
			valueformat:'yyyy-MM-dd'
		},],
		formdata: {
			nsywYxqz:'2099-12-31',
			tuddj:'',
			shuiebz:"",
			nsywYxqq:'',
			shoulswjg: '',
			jingbr: '',
			jingbrsfzhm: '',
			shoulr: '',
			shoulrq: '',
			pikbz: '',
			qudtdsyqje: '',
			tudkfcb: '',
			tudbh: '',
			zondh: '',
			tudmc: '',
			nsrlx: '',
			tudsyqNsrsbh: '',
			tudsyqMc: '',
			budcqzh: '',
			tudxz: '',
			tudyt: '',
			tudqdsj: '',
			tudqdfs: '',
			zhanytdmj: '',
			tudzldzShi: '',
			tudzldzXiangz: '',
			tudzldzXx: '',
			tudsszgsws: '',
			budcdydm: '',
			dij: '',
		},
		headData: [{
				title: "选择",
				prop: "choose",
				width: "50",
				custom: true
			},
			{
				title: "土地编号",
				prop: "tudbh",
				width: 160,
				align: "left",
				custom: true
			},
			{
				title: "宗地号",
				prop: "zondh",
				width: 160,
				align: "left"
			},
			{
				title: "土地名称",
				prop: "tudmc",
				width: 160,
				align: "left"
			},
			{
				title: "不动产权证号",
				prop: "budcqzh",
				width: 160,
				align: "left"
			},
			{
				title: "土地性质",
				prop: "tudxz",
				width: 160,
				align: "left",
				custom: true
			},
			{
				title: "土地用途",
				prop: "tudyt",
				width: 160,
				align: "left",
				custom: true
			},
			{
				title: "占用土地面积",
				prop: "zhanytdmj",
				width: "120",
				AmountFormat: true,
				align: "right"
			},{
				title: "状态",
				prop: "caijFlag",
				width: "120",
				custom: true,
				align: "right"
			},
			{
				title: "操作",
				prop: "cz",
				width: "120",
				custom: true,
				fixed:'right',
				align: "right"
			},
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		}

	}
	return obj
}
